import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NavodayaLanding = () => {
  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 20, fontFamily: "'Nunito', sans-serif" }}>
      <SEO
        title="Navodaya Vidyalaya Entrance Exam Prep – JNVST Class 6 & Class 9"
        description="Prepare for the Navodaya Vidyalaya Entrance Test (JNVST) with free AI-powered mock tests for Class 6 and Class 9 lateral entry. Full syllabus, instant scoring, detailed reports."
        canonical="https://eluvent.com/navodaya"
      />

      <div style={{ textAlign: "center", marginBottom: 30 }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, color: "#1e3a5f", margin: 0 }}>
          🏫 Navodaya Vidyalaya Entrance Exam
        </h1>
        <p style={{ fontSize: 18, color: "#64748b", marginTop: 8 }}>
          Crack JNVST 2027 with AI‑powered mock tests, instant scoring, and detailed feedback.
        </p>
      </div>

      {/* Class 6 Card */}
      <div style={{ background: "white", borderRadius: 20, padding: 24, marginBottom: 20, boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 26, fontWeight: 800, color: "#1e293b", margin: "0 0 8px" }}>
          JNVST Class 6 (Primary Target)
        </h2>
        <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.6, marginBottom: 12 }}>
          The Class 6 entrance exam is the main entry point for Navodaya Vidyalaya. It includes Mental Ability, EVS, Arithmetic, and Language sections – all objective MCQs with no negative marking.
        </p>
        <p style={{ color: "#64748b", fontSize: 13, marginBottom: 16 }}>
          <strong>Total Questions:</strong> 80 &nbsp;|&nbsp; <strong>Total Marks:</strong> 100 &nbsp;|&nbsp; <strong>Duration:</strong> 120 minutes
        </p>
        <Link
          to="/exam-run/navodaya_class6"
          style={{
            display: "inline-block",
            background: "linear-gradient(135deg, #fca311, #ff8c42)",
            color: "white",
            padding: "12px 24px",
            borderRadius: 30,
            fontWeight: 700,
            fontSize: 16,
            textDecoration: "none",
            boxShadow: "0 4px 12px rgba(252,163,17,0.4)"
          }}
        >
          🚀 Start Class 6 Mock Test
        </Link>
      </div>

      {/* Class 9 Card */}
      <div style={{ background: "white", borderRadius: 20, padding: 24, marginBottom: 20, boxShadow: "0 4px 12px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 26, fontWeight: 800, color: "#1e293b", margin: "0 0 8px" }}>
          JNVST Class 9 Lateral Entry (LEST)
        </h2>
        <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.6, marginBottom: 12 }}>
          The lateral entry exam is for admission to Class 9 against vacant seats. It includes English, Hindi, Mathematics, and General Science – each question carries 1 mark, no negative marking.
        </p>
        <p style={{ color: "#64748b", fontSize: 13, marginBottom: 16 }}>
          <strong>Total Questions:</strong> 100 &nbsp;|&nbsp; <strong>Total Marks:</strong> 100 &nbsp;|&nbsp; <strong>Duration:</strong> 150 minutes
        </p>
        <Link
          to="/exam-run/navodaya_class9"
          style={{
            display: "inline-block",
            background: "linear-gradient(135deg, #fca311, #ff8c42)",
            color: "white",
            padding: "12px 24px",
            borderRadius: 30,
            fontWeight: 700,
            fontSize: 16,
            textDecoration: "none",
            boxShadow: "0 4px 12px rgba(252,163,17,0.4)"
          }}
        >
          🚀 Start Class 9 Mock Test
        </Link>
      </div>

      {/* FAQ / Long-tail keywords */}
      <div style={{ background: "#f8fafc", borderRadius: 16, padding: 20, marginTop: 30 }}>
        <h3 style={{ fontSize: 20, fontWeight: 700, color: "#1e293b", marginBottom: 12 }}>❓ Frequently Asked Questions</h3>
        <p style={{ fontWeight: 600, marginBottom: 4 }}>What is the Navodaya exam pattern for Class 6?</p>
        <p style={{ color: "#475569", fontSize: 14, marginBottom: 12 }}>20 Mental Ability, 20 EVS, 20 Arithmetic, and 20 Language questions. Total 80 questions, 100 marks, 120 minutes. No negative marking.</p>
        <p style={{ fontWeight: 600, marginBottom: 4 }}>Is there negative marking in JNVST?</p>
        <p style={{ color: "#475569", fontSize: 14, marginBottom: 12 }}>No, there is no negative marking in the Navodaya entrance exam.</p>
        <p style={{ fontWeight: 600, marginBottom: 4 }}>When is the JNVST 2027 Class 6 exam?</p>
        <p style={{ color: "#475569", fontSize: 14 }}>The exam is scheduled for 28 November 2026. Registration typically opens a few months earlier.</p>
      </div>

      <div style={{ textAlign: "center", marginTop: 24 }}>
        <Link to="/competitive-history" style={{ color: "#7c3aed", fontWeight: 700, textDecoration: "none" }}>
          📊 View My Past Exams
        </Link>
      </div>
    </div>
  );
};

export default NavodayaLanding;